import { createSelector } from 'reselect';
import { OrderedMap } from 'immutable';

// Types
import { WorkspaceAiSettingType } from 'Shared/types/WorkspaceAiSetting.type';

// Constants
import WorkspaceAiSettingsConstants from 'Shared/constants/WorkspaceAiSettings.constants';

function createParameterSelector(selector) {
  return (_, params) => selector(params);
}

const getWorkspaceIdParam = createParameterSelector(params => params.workspaceId);

const getWorkspaceAiSettings = state => state.workspaceAiSettings;

export const getWorkspaceAiSettingsByWorkspaceId = createSelector(
  [getWorkspaceAiSettings, getWorkspaceIdParam],
  (workspaceAiSeetings, workspaceId) => {
    return workspaceAiSeetings
      .getIn([WorkspaceAiSettingsConstants.State.WORKSPACE_AI_SETTINGS_BY_WORKSPACE_SLUG, workspaceId], OrderedMap())
      .valueSeq()
      .toJS() as WorkspaceAiSettingType[];
  }
);
